<mat-accordion class="example-headers-align">
  <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>build</mat-icon>
        Template Creator
      </mat-panel-title>
    </mat-expansion-panel-header>
    <button mat-flat-button color="primary" (click)="openDesignTemplateDialog()" class="vanta-data__templates-create">NEW TEMPLATE</button>
    <mat-divider class="vanta-data__templates-divider"></mat-divider>
    <div class="vanta-data__templates-spinner" *ngIf="!areTemplatesLoaded;else templatesContainer">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <mat-action-row>
      <button mat-button color="primary" (click)="nextStep()">Next</button>
    </mat-action-row>
  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>import_export</mat-icon>
        Export
      </mat-panel-title>
      <mat-panel-description></mat-panel-description>
    </mat-expansion-panel-header>

    <div class="vanta-data__templates-search">
        <div class="spinner spinner--small spinner--noBackgroundEffect" *ngIf="searching">
            <span class="spinSmall"></span>
          </div>
        <form (ngSubmit)="onSubmit(searchForm.value)" autocomplete="off" [formGroup]="searchForm" class="vanta-data__templates-search--form">
         <mat-form-field>
          <mat-label>Method Display Name</mat-label>
          <mat-select formControlName="selectedMethod">
           <mat-option *ngFor="let method of methods" [value]="method">
           {{method}}
           </mat-option>
          </mat-select>
         </mat-form-field>
         <mat-form-field>
          <mat-label>Serial Number</mat-label>
          <mat-select formControlName="selectedSerialNumber">
            <mat-option *ngFor="let serialNumber of serialNumbers" [value]="serialNumber">
              {{serialNumber}}
           </mat-option>
          </mat-select>
         </mat-form-field>
         <mat-form-field>
          <input matInput [matDatepicker]="startDate" placeholder="Start date" formControlName="startDate" (ngModelChange)="validDateRange()">
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>
         </mat-form-field>
         <mat-form-field>
          <input matInput [matDatepicker]="endDate" placeholder="End date" formControlName="endDate" (ngModelChange)="validDateRange()">
          <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
          <mat-datepicker #endDate></mat-datepicker>
         </mat-form-field>
         <mat-error>  
          <span *ngIf="error.isError">{{error.errorMessage}}</span>  
         </mat-error>
         <button mat-flat-button color="primary" class="vanta-data__templates-search--btn" [disabled]="error.isError">
           <mat-icon>search</mat-icon>
           Search
         </button>
        </form>

        <mat-divider></mat-divider>

       <table id="vantaSearchResults" mat-table [dataSource]="dataSource" class="vanta-data__templates-search--results">
         <!-- Checkbox Column -->
         <ng-container matColumnDef="select">
           <th mat-header-cell *matHeaderCellDef>
           <mat-checkbox (change)="$event ? masterToggle() : null"
                   [checked]="selection?.hasValue() && isAllSelected()"
                   [disabled]="this.dataSource === undefined"
                   [indeterminate]="selection?.hasValue() && !isAllSelected()"
                   [aria-label]="checkboxLabel()">
           </mat-checkbox>
           </th>
           <td mat-cell *matCellDef="let row">
           <mat-checkbox (click)="$event.stopPropagation()"
                   (change)="$event ? selection.toggle(row) : null"
                   [checked]="selection?.isSelected(row)"
                   [aria-label]="checkboxLabel(row)">
           </mat-checkbox>
           </td>
         </ng-container>
         
         <!-- Position Column -->
         <ng-container matColumnDef="shotnumber">
           <th mat-header-cell *matHeaderCellDef> SHOT NUMBER </th>
           <td mat-cell *matCellDef="let element"> {{element.shotNumber}} </td>
         </ng-container>
         
         <!-- Name Column -->
         <ng-container matColumnDef="serialnumber">
           <th mat-header-cell *matHeaderCellDef> SERIAL NUMBER </th>
           <td mat-cell *matCellDef="let element"> {{element.serialNumber}} </td>
         </ng-container>
         
         <!-- Weight Column -->
         <ng-container matColumnDef="methoddisplayname">
           <th mat-header-cell *matHeaderCellDef> METHOD DISPLAY NAME </th>
           <td mat-cell *matCellDef="let element"> {{element.methodDisplayName}} </td>
         </ng-container>
         
         <!-- Symbol Column -->
         <ng-container matColumnDef="timestamp">
           <th mat-header-cell *matHeaderCellDef> TIMESTAMP </th>
           <td mat-cell *matCellDef="let element"> {{element.testedDateUtc}} </td>
         </ng-container>
         
         <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
         <tr mat-row *matRowDef="let row; columns: displayedColumns;"
           (click)="selection.toggle(row)">
         </tr>
       </table>
       <div class="results__placeholder" *ngIf="searchResult === null || searchResult?.length === 0">
         <img class="results__placeholder--img" src="assets/img/empty-data.svg" alt="">
         <h3 class="results__placeholder--title">No files found</h3>
       </div>
       <button mat-flat-button color="primary" class="vanta-data__templates-search--btn" (click)="downloadFiles()" *ngIf="searchResult?.length > 0" [disabled]="!isDownloadButtonActive()">
         <mat-icon>cloud_download</mat-icon>
         Download
       </button>
     </div>
    
    <mat-action-row>
      <button mat-button color="secondary" (click)="prevStep()">Previous</button>
      <button mat-button color="primary" (click)="nextStep()">End</button>
    </mat-action-row>
  </mat-expansion-panel>

</mat-accordion>

<ng-template #templatesContainer>
  <p class="vanta-data__templates-header" *ngIf="templates.length>0">Templates for: Vanta Instrument</p>
  <div class="vanta-data__templates-header-no-content" *ngIf="templates.length===0">
    <img class="vanta-data__templates-header-no-content-img" src="assets/img/empty-data.svg" alt="">
    <h3 class="vanta-data__templates-header-no-content-title">No templates found</h3>
  </div>
  <mat-list>
    <mat-list-item class="vanta-data__templates-item" *ngFor="let template of templates; last as last">
      <div class="vanta-data__templates-action" (click)="editTemplate(template)">
        <h3 matLine class="vanta-data__templates-description">{{template.description}}</h3>  
        <mat-icon matListIcon class="vanta-data__templates-action--edit" (click)="editTemplate(template)">edit</mat-icon>
      </div>
      <div class="vanta-data__templates-delete-container">
        <mat-icon matListIcon class="vanta-data__templates-delete" (click)="deleteTemplate(template)">close</mat-icon>
      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    </mat-list-item>
  </mat-list>
</ng-template >
